import React, { VFC } from 'react';
import { ClientSideWizardFlowPresenter } from '../../../content-composer/src/components/ClientSideWizard/ClientSideWizardFlowPresenter';
import { useWizardGoToPreviousStep } from '../../../content-composer/src/contexts/ClientSideWizard/hooks';
import {
  useIsAuthFlowDrawerOpen,
  useOnSetAuthAction,
  useOnSetRequestNewRate,
  useOnToggleAuthFlowDrawer,
} from '../contexts';
import { useApproveRejectFlowConfig } from './useApproveRejectFlowConfig';

export interface ApproveRejectAuthFlowPresenterProps {
  authAction: string | null;
  onToggleDrawer: () => void;
  isBulk?: boolean;
}

export enum ProcessStatuses {
  NONE = 'NONE',
  PENDING = 'PENDING',
}

const mandatesFlowPreloadedData = {
  data: {
    mandateInfo: {
      stepId: 'mandateInfo',
      values: {},
    },
    rejectReasonStep: {
      stepId: 'rejectReasonStep',
      values: {},
    },
    mandateInitiate: {
      stepId: 'mandateInitiate',
      values: {},
    },
    mandateExecute: {
      stepId: 'mandateExecute',
      values: {},
    },
  },
};

const ApproveRejectAuthFlowPresenter: VFC<ApproveRejectAuthFlowPresenterProps> = ({
  authAction,
  onToggleDrawer,
  isBulk,
}) => {
  const isAuthFlowDrawerOpen = useIsAuthFlowDrawerOpen();
  const setRequestRate = useOnSetRequestNewRate();
  const setAuthAction = useOnSetAuthAction();
  const goToPreviousStep = useWizardGoToPreviousStep();
  const onToggleAuthFlowDrawer = useOnToggleAuthFlowDrawer();

  const flowConfig = useApproveRejectFlowConfig(authAction, onToggleDrawer, isBulk, () => {
    if (isAuthFlowDrawerOpen) {
      onToggleAuthFlowDrawer();
    }
    goToPreviousStep();
    setRequestRate(false);
    setAuthAction(null);
  });

  if (authAction === null) {
    return null;
  }

  return (
    <ClientSideWizardFlowPresenter
      processName={'mandates-flow'}
      preloadedFormDataConfig={mandatesFlowPreloadedData}
      stepsConfig={flowConfig.data}
      isTakeover={true}
      shouldEnablePaddingBottom={false}
    />
  );
};

export { ApproveRejectAuthFlowPresenter };
